<template>
    <div class="progress l" :title="value" :style="{height: height + 'px'}">
        <div :style="{width: value + '%', backgroundColor: color}" :class="'progress-bar bg-' + type" aria-valuemin="0" aria-valuemax="100" role="progressbar" :aria-valuenow="value">
            <span class="sr-only">{{ value + '% '}}</span>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            value: {
                required: true
            },
            type: {
                default: ''
            },
            height: {
                default: 20
            },
            color: {
                default: null
            }
        }
    }
</script>

<style scoped lang="scss">
    .progress {
        border-radius: 0.125rem;
    }
</style>
